<template>
  <div class="input-container">
    <div class="field-name"><img class="field-icon" src="/ics/property/img/templates/icon/map.svg"><span>{{ $t('find.DISTRICT') }}</span></div>
    <div>
      <button
        type="button"
        class="btn btn-default btn-block filter-button"
        @click="toggleMobileDistrict()"
      >
        <span class="current-option">{{ name }}</span>
        <span class="down-arrow">
          <span 
            class="glyphicon"
            :class="{ 'glyphicon-chevron-down': !mobileDistrictActive, 'glyphicon-chevron-up': mobileDistrictActive }"
          ></span>
        </span>
      </button>
    </div>
    <transition name="slide-fade">
      <mobile-district
        v-show="mobileDistrictActive"
        @changeDistrict="$emit('changeDistrict', $event)"
        :selectedIcs="ics"
        :selectedDistricts="districts"
      ></mobile-district>
    </transition>
  </div>
</template>

<script>
import MobileDistrict from '@/components/Stock/Filters/MobileDistrict';

export default {
  components: { MobileDistrict },
  props: ['name', 'ics', 'districts'],
  data() {
    return {
      mobileFilterPrePosition: false,
      mobileDistrictActive: false,
      mobileTempDistrict: [],
    };
  },
  methods: {
    toggleMobileDistrict() {
      if (this.mobileDistrictActive) {
        this.$nextTick(() => {
          window.scrollTo(0, this.mobileFilterPrePosition);
        });
      } else {
        this.mobileFilterPrePosition = window.scrollY;
        window.scrollTo(0, 0);
      }
      this.mobileDistrictActive = !this.mobileDistrictActive;
    },
  },
};
</script>

<style scoped>
.input-container {
  background: #ffffbb;
  margin: 5px 0;
  padding: 5px;
  border-radius: 4px;
}

.field-name {
  display: flex;
  font-weight: 400;
  font-size: 16px;
}

.field-icon {
  width: 16px;
  height: auto;
  margin-right: 5px;
  align-self: center;
}

.filter-button {
  text-align: left;
  background: #ffffbb;
  padding: 4px 0 0 0;
  box-shadow: unset;
  outline-width: 0px;
  display: flex;
  justify-content: space-between;
}

.filter-button:focus, .filter-button:active, .filter-button:hover {
  background: #ffffbb;
  outline-width: 0px;
  box-shadow: unset;
}

.filter-button.active:hover {
  box-shadow: unset;
}

.current-option {
  color: #8D8D8D;
  font-size: 14px;
  white-space: break-spaces;
}

.down-arrow {
  font-size: 16px;
}
</style>
